import bem from './bem';
import bemSsr from './bemSsr';
import anchor from './anchor';

export default function (Vue) {
  Vue.directive('bem', bem);
  Vue.directive('anchor', anchor);
  Vue.directive('bem-ssr', bemSsr);
}



// WEBPACK FOOTER //
// ../src/plugin/directive/index.js